import i18n from "i18next";
import * as Webapi from "@ihr-radioedit/inferno-webapi";

import { resolveMenu } from "./menu";
import { reverseRoute } from "./route";
import { slugify } from "./utilities";
import { SitesMenu } from "../chrome/Navigation.component";
import { Store } from "../../../client/stores";

export const addContests = (
    contests: Webapi.AptivadaAppFragment[],
    resolvedMenus: SitesMenu[],
    store: Store,
    brandIds?: { [key: string]: string },
) => {
    let contestsMenuIndex = resolvedMenus.findIndex(m => (m.label ? m.label.toLowerCase() === "contests" : false));
    contestsMenuIndex = contestsMenuIndex > -1 ? contestsMenuIndex : resolvedMenus.length;
    if (!resolvedMenus[contestsMenuIndex]) {
        resolvedMenus.push({
            type: "link",
            label: i18n.t("promotions"),
            children: [],
            ref: "#",
        });
    }
    for (let i = contests.length - 1; i >= 0; i--) {
        const contest = contests[i];
        const menuItem: SitesMenu = {
            type: "link",
            label: contest.title.trim(),
            href: store?.site
                ? contest.gridRedirect ||
                  reverseRoute(store?.site, "promotion", {
                      slug: `${slugify(contest.title.trim(), 6)}-${contest.appId}`,
                  })
                : "#",
            context: `contest_${i}`,
        };
        const { children } = resolvedMenus[contestsMenuIndex];
        if (children) {
            children.unshift(menuItem);
        }
    }
    const { children: contestsMenu } = resolvedMenus[contestsMenuIndex];

    if (contestsMenu) {
        const { navigation } = store?.site?.sections ?? {};
        if (navigation?.national_promotions) {
            navigation?.national_promotions.map(menu =>
                contestsMenu.push(resolveMenu(menu, store?.env.MICROSITE_ROOT, null, store?.site, brandIds)),
            );
        }
        if (contests.length) {
            contestsMenu.push({
                type: "link",
                label: i18n.t("all_promotions"),
                href: reverseRoute(store?.site, "promotions"),
            });
        }
        contestsMenu.push({
            type: "link",
            label: i18n.t("contest_rules"),
            href: reverseRoute(store?.site, "rules"),
        });
    }

    return resolvedMenus;
};
